import objectPath from 'object-path'

export const getActionOrder = (uischema) => {
  let tableAction = objectPath.get(uischema, 'tableAction')
  let actionOrder = objectPath.get(tableAction, 'actionOrder')
  if (!actionOrder) {
    actionOrder = {}
    const action = tableAction?.action || []
    const addAction = action.find((item) => item.name === 'add') || {
      isActive: false,
    }
    const printAction = action.find((item) => item.name === 'print') || {
      isActive: false,
    }
    const selectionAction = tableAction?.selection || { isActive: false }
    if (printAction?.isActive) {
      objectPath.set(actionOrder, 'print', {
        key: 'print',
        align: 'left',
        order: 0,
      })
    }
    if (selectionAction?.isActive) {
      objectPath.set(actionOrder, 'selection', {
        key: 'selection',
        align: 'right',
        order: 1,
      })
    }
    if (addAction?.isActive) {
      objectPath.set(actionOrder, 'add', {
        key: 'add',
        align: 'right',
        order: 2,
      })
    }
  }
  let orderList = Object.values(actionOrder).sort((a, b) => {
    if (a.order < b.order) return -1
    if (a.order > b.order) return 1
    return 0
  })
  return orderList
}

export const getButtonPosition = (actionOrder) => {
  let buttonPosition = []
  actionOrder.forEach((value, index) => {
    let addClassName = []
    let align = actionOrder[index]?.align
    let prev = objectPath.get(actionOrder, index - 1) || {}
    let next = objectPath.get(actionOrder, index + 1) || {}
    let prevAlign = prev?.align
    let nextAlign = next?.align

    if (align === 'left') {
      buttonPosition.push('mx-1')
    } else if (align === 'center') {
      if (prevAlign === 'center') {
        addClassName.push('ml-1')
      } else {
        addClassName.push('ml-auto')
      }
      if (nextAlign === 'center') {
        addClassName.push('mr-1')
      } else {
        addClassName.push('mr-auto')
      }
      addClassName = addClassName.join(' ')
      buttonPosition.push(addClassName)
    } else if (align === 'right') {
      if (prevAlign === 'center' || prevAlign === 'right') {
        addClassName.push('ml-1')
      } else {
        addClassName.push('ml-auto')
      }
      addClassName.push('mr-1')
      addClassName = addClassName.join(' ')
      buttonPosition.push(addClassName)
    }
  })
  return buttonPosition
}
